import { FormaExpandedTooltip } from '@/components/UI/FormaExpandedTooltip/FormaExpandedTooltip';
import styles from './styles.module.scss';

interface BonusContribution {
	label: string;
	weight: number;
	weighted: number;
}

interface BonusBreakdownProps {
	id: string;
	score: number;
	contributions: BonusContribution[];
}

export const BonusBreakdown = ({ id, score, contributions }: BonusBreakdownProps) => {
	return (
		<FormaExpandedTooltip
			loadingduration={500}
			position="left"
			text="Bonus Breakdown"
			targetId={id}
		>
			<div className={styles.scoreSummary}>
				<div className={styles.summaryTitle}>
					<strong>Score: {score.toFixed(2)}</strong>
					<span>Max: 4.00</span>
				</div>

				<div className={styles.simpleRecommendation}>
					Environmental bonus is calculated from water and acoustic inputs.
				</div>

				<div className={styles.simpleTable}>
					{contributions.map((item) => (
						<div key={item.label} className={styles.tableRow}>
							<div className={styles.rowInfo}>
								<span>{item.label}</span>
								<span
									className={
										item.weighted > 0 ? styles.textSuccess : styles.mutedText
									}
								>
									{item.weighted > 0 ? 'Included' : 'Not included'}
								</span>
							</div>
							<div className={styles.rowMeta}>
								Weight: {item.weight} | Contribution: +{item.weighted}
							</div>
						</div>
					))}
				</div>
			</div>
		</FormaExpandedTooltip>
	);
};
